import React from 'react';
import PropTypes from 'prop-types';
import './Info.scss';

const Info = props => {
    return (
        <div className={`${props.display === "show" ? "active" : "hidden"}`}>
            <div className="dash__wrap">
                <h2>Documentation</h2>

                <div className="flex flex-items-center flex-justify-center gap__container">
                    <div className="metrics__container">
                        <div className={`shadow metrics__wrapper`}>
                            <h4>Game Overview</h4>
                            <hr/>
                            <ul>
                                <li className="pdf manual"><a href="http://clsgrest.com/wp-content/uploads/2019/02/HN-Player-Quickstart.pdf" className="nombore">
                                    User Quickstart<span className="slider"/></a></li>
                                <li className="video manual"><a href="https://vimeo.com/317717003" className="nombore">
                                    Competition Overview<span className="slider"/></a></li>
                                <br/>
                                <li className="pdf manual"><a href="http://clsgrest.com/wp-content/uploads/2019/02/HN-Player-Manual.pdf" className="nombore">
                                    Player Manual<span className="slider"/></a></li>
                                <li className="video manual"><a href="https://vimeo.com/315549033" className="nombore">
                                    Player Video<span className="slider"/></a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                {props.isInstructor &&

                <div className="flex flex-items-center flex-justify-center gap__container">
                    <div className="metrics__container">
                        <div className={`shadow metrics__wrapper`}>
                            <h4>Instructor Manual</h4>
                            <hr/>
                            <ul>
                                <li className="pdf manual"><a href="http://clsgrest.com/wp-content/uploads/2019/02/Hn-Instructor-Quickstart.pdf" className="nombore">
                                    Instructor Quickstart<span className="slider"/></a></li>
                                <li className="pdf manual"><a href="http://clsgrest.com/wp-content/uploads/2019/02/HN-how-to-start-next-game.pdf" className="nombore">
                                    End One Game / Start Another<span className="slider"/></a></li>
                                <li className="pdf manual"><a href="http://clsgrest.com/wp-content/uploads/2019/02/HN-Instructor-Manual.pdf" className="nombore">
                                    Instructor Manual<span className="slider"/></a></li>
                                <li className="video manual"><a href="https://vimeo.com/314899689" className="nombore">
                                    Instructor Video<span className="slider"/></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                }

                {/*<div className="flex flex-items-center flex-justify-center gap__container">*/}
                    {/*<div className="metrics__container">*/}
                        {/*<div className={`shadow metrics__wrapper`}>*/}
                            {/*<h4>User Interface</h4>*/}
                            {/*<hr/>*/}
                            {/*<ul>*/}
                                {/*<li className="pdf manual"><a href="/" className="nombore">*/}
                                    {/*User Interface Manual<span className="slider"/></a></li>*/}
                                {/*<li className="video manual"><a href="/" className="nombore">*/}
                                    {/*User Interface Manual<span className="slider"/></a></li>*/}
                            {/*</ul>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}

            </div>
        </div>
    )
};

Info.propTypes = {
    display: PropTypes.string.isRequired,
    isInstructor: PropTypes.bool,
};

export default Info;
